// Utility to sanitize form input and remove dangerous HTML/script tags
export function sanitizeInput(value: string): string {
  if (typeof value !== 'string') return value;
  // Remove script, iframe, and other dangerous tags
  return value.replace(/<\/?(script|iframe|object|embed|style|link|meta)[^>]*>/gi, '')
              .replace(/on\w+\s*=\s*(['"]).*?\1/gi, '') // Remove inline event handlers
              .replace(/javascript:/gi, '');
}
